import { render, staticRenderFns } from "./shortage_calculation.vue?vue&type=template&id=24593db4&scoped=true&"
import script from "./shortage_calculation.vue?vue&type=script&lang=js&"
export * from "./shortage_calculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24593db4",
  null
  
)

export default component.exports